import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import Select from 'react-select'

class QCInfoForm extends React.Component {
  static propTypes = {
    qcResults: PropTypes.shape({
      created_at: PropTypes.string
    }),
    updateQc: PropTypes.func,
    controlMaterials: PropTypes.shape({}),
    site: PropTypes.shape({}),
    router: PropTypes.shape({}),
    qcId: PropTypes.any,
    deviceString: PropTypes.string,
    operator: PropTypes.string,
    controlMaterialId: PropTypes.number,
    testStripLot: PropTypes.string,
    note: PropTypes.string,
    setControlMaterial: PropTypes.func,
    setTestStripLot: PropTypes.func,
    setNote: PropTypes.func,
    setOperator: PropTypes.func,
  }

  static defaultProps = {
    qcResults: {},
    loadDevices: _.noop,
    getControlMaterials: _.noop,
    controlMaterials: {},
    router: {},
    site: {},
    qqcId: null,
    deviceString: null,
    operator: '',
    controlMaterialId: null,
    testStripLot: null,
    note: '',
    setControlMaterial: _.noop,
    setTestStripLot: _.noop,
    setNote: _.noop,
    setOperator: _.noop,
  }

  submitForm = (e) => {
    const { updateQc, qcId, deviceString, controlMaterialId, note, operator } = this.props
    updateQc(qcId, { deviceString, controlMaterialId, note, operator })
    e.preventDefault()
  }

  render () {
    const { qcResults, controlMaterials, qcId, setControlMaterial, setNote, setOperator, setTestStripLot, controlMaterialId, testStripLot, note, deviceString, operator } = this.props
    let selectedLot = null

    if (controlMaterialId) {
      selectedLot = controlMaterials[controlMaterialId]
    }

    const lotOptions = _.map(
      controlMaterials, (lot) => ({ value: lot, label: lot.lot_number })
    )

    return (
      <div>
        <h4>Lot Verification Test</h4>
        <form noValidate autoComplete='off'>
          <div className='form-group row'>
            <label className='col-sm-2 col-form-label'>
              <span>QC ID</span>
            </label>
            <div className='col-sm-10'>
              <div style={{ marginLeft: -15, marginRight: -15 }}>
                { qcId }
              </div>
            </div>
          </div>
          <div className='form-group row'>
            <label className='col-sm-2 col-form-label'>
              <span>Test Date</span>
            </label>
            <div className='col-sm-10'>
              <div style={{ marginLeft: -15, marginRight: -15 }}>
                { qcResults.created_at }
              </div>
            </div>
          </div>

          <div className='form-group row'>
            <label className='col-sm-2 col-form-label'>
              <span>Device</span>
            </label>
            <div className='col-sm-10'>
              <div style={{ marginLeft: -15, marginRight: -15 }}>
                {deviceString}
              </div>
            </div>
          </div>

          <div className='form-group row'>
            <label className='col-sm-2 col-form-label'>
              <span>Test Operator</span>
            </label>
            <input
              className='form-control col-sm-10'
              type='text'
              placeholder={'operator'}
              value={operator}
              onChange={(e) => setOperator(e.target.value)}
            />
          </div>

          <div className='form-group row'>
            <label className='col-sm-2 col-form-label'>
              <span>Control Lot</span>
            </label>
            <div className='col-sm-10'>
              <div style={{ marginLeft: -15, marginRight: -15 }}>
                <Select
                  className='control-selector'
                  placeholder={'Select Control Lot'}
                  isSearchable
                  onChange={(e) => setControlMaterial(e.value.id)}
                  options={lotOptions}
                  value={selectedLot ? {
                    value: selectedLot,
                    label: `${selectedLot.lot_number}`
                  } : null}
                />
              </div>
            </div>
          </div>

          <div className='form-group row'>
            <label className='col-sm-2 col-form-label'>
              <span>Test Strip Lot</span>
            </label>
            <input
              className='form-control col-sm-10'
              type='text'
              placeholder={'Test-Strip Lot'}
              value={testStripLot}
              onChange={(e) => setTestStripLot(e.target.value)}
            />
          </div>


          <div className='form-group row'>
            <label className='col-sm-2 col-form-label'>
              <span>Note</span>
            </label>
            <input
              className='form-control col-sm-10'
              type='text'
              placeholder={'note'}
              value={note}
              onChange={(e) => setNote(e.target.value)}
            />
          </div>
        </form>
      </div>
    )
  }
}

export default QCInfoForm



// WEBPACK FOOTER //
// ./src/routes/QC/components/QCInfoForm.jsx